import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, serverTimestamp } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

export const firebaseConfig = {
  apiKey: "AIzaSyCk-RaSz8960A_CHOn_qWZysXIUonmeBdY",
  authDomain: "bgi-research-portal.firebaseapp.com",
  projectId: "bgi-research-portal",
  storageBucket: "bgi-research-portal.firebasestorage.app",
  messagingSenderId: "517419046077",
  appId: "1:517419046077:web:b316ace80328514734d3d4"
};

export const FUNCTIONS_REGION = "us-central1";

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, FUNCTIONS_REGION);

export { serverTimestamp };
